import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1322599e&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=1322599e&prod&lang=scss"
import style1 from "./Header.vue?vue&type=style&index=1&id=1322599e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322599e",
  null
  
)

export default component.exports